var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { DefaultRequestPolicies, InitialPointerState } from './constants';
import { ChangeTracker } from './changeTracker';
export function mapMerge(scope, state, pointers, callback) {
    var e_1, _a, _b;
    var tracker = new ChangeTracker(state, scope);
    var scopeState = state.data[scope] || {};
    var updatedTypes = new Set();
    var updates = {};
    var i = 0;
    for (i = 0; i < pointers.length; i++) {
        var pointer = pointers[i];
        var bucket = pointer.bucket, id = pointer.id;
        var stringifiedId = String(id);
        var existingRefState = scopeState[bucket] && scopeState[bucket][id];
        var nextPointerState = void 0;
        if (existingRefState) {
            var mergeRefState = callback(existingRefState, i, tracker);
            if (mergeRefState && mergeRefState !== existingRefState) {
                nextPointerState = __assign(__assign({}, existingRefState), mergeRefState);
            }
        }
        else {
            var initialState = __assign(__assign({}, InitialPointerState), { pointer: pointers[i] });
            var mergeState = callback(initialState, i, tracker);
            if (mergeState &&
                mergeState !== initialState &&
                (mergeState.value || !canPurge(mergeState))) {
                nextPointerState = __assign(__assign({}, initialState), mergeState);
            }
        }
        if (!nextPointerState) {
            continue;
        }
        var invalidated = nextPointerState.invalidated, _c = nextPointerState.modifiers, pause = _c.pause, pending_1 = _c.pending, request = nextPointerState.request, tasks = nextPointerState.tasks, value = nextPointerState.value;
        var existingPause = existingRefState && existingRefState.modifiers.pause;
        var existingRequestPolicies = existingRefState && existingRefState.request
            ? existingRefState.request.policies
            : DefaultRequestPolicies;
        var requestPolicies = request ? request.policies : DefaultRequestPolicies;
        var nextTasks = (nextPointerState.tasks = __assign({}, tasks));
        if (canPurge(nextPointerState)) {
            if (tasks.purge === null) {
                nextTasks.purge = tracker.startCacheTask('purge', pointer, nextPointerState);
            }
        }
        else {
            if (tasks.purge) {
                nextTasks.purge = null;
            }
            if (tasks.load) {
                if (requestPolicies.loadInvalidated + requestPolicies.loadOnce === 0) {
                    nextTasks.load = null;
                }
                else {
                    if (pause && !existingPause) {
                        tracker.pausePointerTask(pointer, tasks.load);
                    }
                    else if (!pause && existingPause) {
                        tracker.unpauseRefTask(pointer, tasks.load);
                    }
                }
            }
            else if (tasks.load === null &&
                tasks.manualLoad === null &&
                !pause &&
                !pending_1 &&
                ((requestPolicies.loadInvalidated && (invalidated || !value)) ||
                    (requestPolicies.loadOnce && !existingRequestPolicies.loadOnce))) {
                nextTasks.load = tracker.startRequestTasks('load', pointer, request.instance);
            }
            if (tasks.invalidate) {
                if (invalidated ||
                    (requestPolicies.subscribe && tasks.subscribe !== false)) {
                    nextTasks.invalidate = null;
                }
            }
            else if (tasks.invalidate === null &&
                value &&
                !invalidated &&
                (!requestPolicies.subscribe || tasks.subscribe === false)) {
                nextTasks.invalidate = tracker.startCacheTask('invalidate', pointer, nextPointerState);
            }
            if (tasks.subscribe) {
                if (!requestPolicies.subscribe) {
                    nextTasks.subscribe = null;
                }
            }
            else if (tasks.subscribe === null && requestPolicies.subscribe) {
                nextTasks.subscribe = tracker.startRequestTasks('subscribe', pointer, request.instance);
            }
        }
        if (existingRefState && existingRefState.tasks !== nextPointerState.tasks) {
            tracker.removePointerFromTasks(pointer, existingRefState.tasks, nextPointerState.tasks);
        }
        updatedTypes.add(bucket);
        if (!updates[bucket]) {
            updates[bucket] = {};
        }
        updates[bucket][stringifiedId] = nextPointerState;
    }
    if (updatedTypes.size === 0) {
        // No changes to records means no changes to tasks either, so bail early.
        return state;
    }
    var nextScopeState = __assign({}, scopeState);
    try {
        for (var _d = __values(updatedTypes.values()), _e = _d.next(); !_e.done; _e = _d.next()) {
            var type = _e.value;
            nextScopeState[type] = __assign(__assign({}, scopeState[type]), updates[type]);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return tracker.buildNextState(__assign(__assign({}, state.data), (_b = {}, _b[scope] = nextScopeState, _b)));
}
function canPurge(_a) {
    var _b = _a.modifiers, modifiers = _b === void 0 ? { keep: 0, pause: 0, pending: 0 } : _b, request = _a.request, tasks = _a.tasks;
    var requestPolicies = request ? request.policies : DefaultRequestPolicies;
    return (!(tasks && tasks.manualLoad) &&
        !(modifiers.keep +
            modifiers.pause +
            modifiers.pending +
            requestPolicies.loadInvalidated +
            requestPolicies.loadOnce +
            requestPolicies.subscribe));
}
//# sourceMappingURL=mapMerge.js.map